// extracted by mini-css-extract-plugin
export default {"button":"LoginPrd_button__enwP7"};